var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 45.05 17.4 38.4q-.7-.2-1.55-.7-.85-.5-1.4-.95l-6.2 2.85-5.65-10 5.65-4.1q-.05-.25-.05-.725v-1.5q0-.425.05-.775L2.6 18.3l5.65-9.9 6.3 2.85q.5-.35 1.35-.85.85-.5 1.5-.7l1.05-6.8H29.6l1 6.75q.75.2 1.575.7.825.5 1.375.9l6.3-2.85 5.6 9.9-5.75 4.05q.05.4.125.85.075.45.075.8 0 .35-.075.775-.075.425-.125.775l5.75 4.05-5.7 10-6.2-2.85q-.55.45-1.425.975-.875.525-1.475.675l-1.05 6.65Zm5.5-14.7q2.65 0 4.5-1.85T30.3 24q0-2.6-1.85-4.475-1.85-1.875-4.5-1.875-2.7 0-4.525 1.875Q17.6 21.4 17.6 24q0 2.65 1.825 4.5t4.525 1.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/settings_FILL1_wght700_GRAD200_opsz48.c23033fa91d0c372bc1a7d7830875261.svg";
export { ForwardRef as ReactComponent };